import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import Button from "@/components/buttons/Button.tsx";

import { ROUTES } from "@/config/routes.ts";

const TitleSection = (): JSX.Element => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const push = (route: string) => {
    navigate(route);
  };

  return (
    <div className={"mt-6"}>
      <ul className={"flex gap-2.5 max-md:gap-2"}>
        <li>
          <Button
            color={pathname === ROUTES.HISTORY ? "orange" : "black"}
            onClick={() => push(ROUTES.HISTORY)}
            size="medium"
            className={"h-[3rem] px-4"}
          >
            {t("General.watch-history")}
          </Button>
        </li>
        <li>
          <Button
            color={pathname === ROUTES.FAVORITES ? "orange" : "black"}
            onClick={() => push(ROUTES.FAVORITES)}
            size="medium"
            className={"h-[3rem]  px-4"}
          >
            {t("General.favorite", { count: 2 })}
          </Button>
        </li>
      </ul>
    </div>
  );
};

export default TitleSection;
